import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MaterialModule } from '../material.module';
import { BreadcrumbComponent } from '../shared/components/breadcrumb/breadcrumb.component';
import { PipesModule } from '../shared/pipes.module';
import { SharedModule } from '../shared/shared.module';
import { QueriesDialogComponent } from './queries-dialog/queries-dialog.component';

@NgModule({
  imports: [CommonModule, MaterialModule, PipesModule, SharedModule, BreadcrumbComponent],
  declarations: [QueriesDialogComponent],
  exports: [QueriesDialogComponent],
})
export class QueriesModule {}
